import { apiBaseUrls } from "src/platform/constants/shared-constants";
import API from "src/platform/http/shared-http";

export interface IQuickStartApplication {
  name: string;
  description: string;
  git_repo: string;
  alias: string;
  icon: string;
  quickstart_feature: {
    feature: {
      name: string;
      description: string;
      alias: string;
    };
  }[];
}

const QUICK_START = "/api/v1/quick_start";

class QuickStartService {
  public static async getQuickStartApplications(): Promise<
    IQuickStartApplication[]
  > {
    const api = new API(apiBaseUrls.BACKEND, `${QUICK_START}`);
    return api.get<IQuickStartApplication[]>();
  }
}

export default QuickStartService;
